module["exports"] = [
  "deposit",
  "withdrawal",
  "payment",
  "invoice"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/finance/transaction_type.js
// module id = 2081
// module chunks = 2